import { gql } from "@apollo/client";

export const BUY_ADDONS = gql`
  mutation buyAddons($projectId: ID!, $newAddonIds: [ID!]!, $removedAddonIds: [ID!]!) {
    buyAddons(projectId: $projectId, newAddonIds: $newAddonIds, removedAddonIds: $removedAddonIds)
  }
`;
